import styles from "./Account.module.css"
import { useState, useEffect } from 'react';
import SecondaryButton from "../../../../../components/Button/SecondaryButton/SecondaryButton";
import FillInField from "../../../../../components/Input/FillInField/FillInField";
import { useTranslation } from "react-i18next";
import { useUserContext } from "../../../../../context/UserContext";
import { useOrderContext } from "../../../../../context/OrderContext";
import { Subscriber, userDataTypes } from "../../../../../types/auth.types";
import { log } from "../../../../../utils/logger";
/**
* Account page
* Contains users detailed info and a form for changing name, phone and position
* @returns TSX.Element
*/
const AccountPage = () => {
    const { t } = useTranslation(); // Translation
    const [name, setName] = useState("");
    const [position, setPosition] = useState("");
    const [phone, setPhone] = useState<number | null>(null);
    // Handle phone input
    const handlePhone = (val: number| string| null) => {
        if(!isNaN(Number(val))){
            setPhone(Number(val))
        }
    }


    const { userData } = useUserContext();
    const { orderData } = useOrderContext();
    // Fetch adresses
    const [sub, setSub] = useState<Subscriber | undefined>()
    useEffect(() => {
        const tempUser = userData.subscribers?.find(sub => sub.subscriber_id === orderData.recipient)
        setSub(tempUser)
    },[userData])


    return(
        <>
            <div className={styles.AccountPageContent}>
                <p className={styles.AccountPageContentTitle}>{t("account.titles.settings")}</p>
                <div className={styles.AccountPageContentCenter}>
                    <div className={styles.BaseInfo}>
                        <p className={styles.BaseInfoTitle}>{t("account.settings.base_form_title")}</p>
                        <div className={styles.BaseInfoContent}>

                            <div className={`${styles.InfoRow} ${styles.RowWrap}`}>
                                <FillInField
                                    label={t("account.settings.inputs.name.title")}
                                    placeholder={`${t("account.settings.inputs.name.placeholder")}`}
                                    disabled={true}
                                    value={userData.fullname ?? ""}
                                />
                                <FillInField
                                    label={t("account.settings.inputs.position.title")}
                                    placeholder={`${t("account.settings.inputs.position.placeholder")}`}
                                    value={userData.position ?? ""}
                                    disabled={true}
                                />
                            </div>
                            <div className={styles.InfoRow}>
                                <FillInField
                                    label={t("account.settings.inputs.phone.title")}
                                    placeholder={`${t("account.settings.inputs.phone.placeholder")}`}
                                    value={userData.phone_number ??  ""}
                                    disabled={true}
                                />
                                <FillInField
                                    label={t("account.settings.inputs.email.title")}
                                    placeholder={`${t("account.settings.inputs.email.placeholder")}`}
                                    value={userData.email ??  ""}
                                    disabled={true}
                                />
                            </div>

                            <div className={styles.InfoRow}>
                                <div className={styles.InputGroup}>
                                    <FillInField
                                        label={t("account.settings.inputs.company.title")}
                                        placeholder={`${t("account.settings.inputs.company.placeholder")}`}
                                        value={sub?.name ?? ""}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className={styles.InfoRow}>
                                <FillInField
                                    label={t("account.settings.inputs.ic.title")}
                                    placeholder={`${t("account.settings.inputs.ic.placeholder")}`}
                                    value={sub?.ic ?? ""}
                                    disabled={true}
                                />
                                <FillInField
                                    label={t("account.settings.inputs.dic.title")}
                                    placeholder={`${t("account.settings.inputs.dic.placeholder")}`}
                                    value={sub?.dic ?? ""}
                                    disabled={true}
                                />
                            </div>
                            <div className={`${styles.InfoRow} ${styles.RowWrap}`}>
                                <div className={styles.InfoRow}>
                                    <FillInField
                                        label={t("account.settings.inputs.street.title")}
                                        placeholder={`${t("account.settings.inputs.street.placeholder")}`}
                                        value={sub?.street ?? ""}
                                        disabled={true}
                                    />
                                    <FillInField
                                        label={t("account.settings.inputs.city.title")}
                                        placeholder={`${t("account.settings.inputs.city.placeholder")}`}
                                        value={sub?.city ?? ""}
                                        disabled={true}
                                    />
                                </div>
                                <div className={styles.InfoRow}>
                                    <FillInField
                                        label={t("account.settings.inputs.post.title")}
                                        placeholder={`${t("account.settings.inputs.post.placeholder")}`}
                                        value={sub?.postal_code ?? ""}
                                        disabled={true}
                                    />
                                    <FillInField
                                        label={t("account.settings.inputs.country.title")}
                                        placeholder={`${t("account.settings.inputs.country.placeholder")}`}
                                        value={sub?.country ?? ""}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={styles.PersonalInfo}>
                        <p className={styles.PersonalInfoTitle}>{t("account.settings.account_form_title")}</p>
                        <div className={`${styles.InfoRow} ${styles.RowWrap}`}>
                                <FillInField
                                    label={t("account.settings.inputs.name.title")}
                                    placeholder={`${t("account.settings.inputs.name.placeholder")}`}
                                    value={name ? name : ""}
                                    onChange={(value) => setName(String(value))}
                                />
                                <FillInField
                                    label={t("account.settings.inputs.position.title")}
                                    placeholder={`${t("account.settings.inputs.position.placeholder")}`}
                                    value={position ? position : ""}
                                    onChange={(value) => setPosition(String(value))}
                                />
                        </div>
                        <div className={styles.InfoRow}>
                            <FillInField
                                label={t("account.settings.inputs.phone.title")}
                                placeholder={`${t("account.settings.inputs.phone.placeholder")}`}
                                value={phone!==null ? phone: ""}
                                type="tel"
                                onChange={(value) => handlePhone(Number(value))}
                            />
                            <FillInField
                                label={t("account.settings.inputs.email.title")}
                                placeholder={`${t("account.settings.inputs.email.placeholder")}`}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <SecondaryButton
                    text={t("buttons.save_changes")}
                    onClick={()=>alert("clicked")}
                    disabled={name === "" || phone === null || position === ""}
                    />
                </div>
            </div>
        </>
    )
}

export default AccountPage;
